export const Marquee = () => {
  const items = ["Dream", "Pursue", "Become"];
  const row = [...items, ...items, ...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative py-10 lg:py-14 bg-[#F3EFEA] overflow-hidden border-y border-black/5"
    >
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((word, i) => (
              <span key={i} className="flex items-center">
                <span className="text-5xl sm:text-7xl lg:text-8xl font-black tracking-tight text-outline px-6">
                  {word}
                </span>
                <span className="w-4 h-4 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-[#FE7815] to-[#F01E1F] mx-4 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
